const getters = {
    downloadDocument: (state) => state.downloadDocument,
    loading: state => state.loading
};

export default getters;